<template id="bs-modal">
  <div class="modal fade" id="navModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <ul class="nav flex-column">
            <li class="nav-item">
              <router-link to="/impressum" data-dismiss="modal" class="nav-link">Impressum</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/dsvgo" data-dismiss="modal" class="nav-link">Datenschutzerklärung</router-link>
            </li>
          </ul>  
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Schliessen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar.Extra"
};
</script>
